module.exports = __webpack_public_path__ + "img/21_66.f2ebe169.png";